import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { FiChevronRight, FiPlus, FiX } from "react-icons/fi"

import "./header.scss"
import {
  AnimatePresence,
  motion,
  useCycle,
  useViewportScroll,
} from "framer-motion"
import autoprefixer from "autoprefixer"

const mobileMenu = {
  open: {
    // top: "0",
    width: "300px",
    // x: 0,
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
      staggerDirection: 1,
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.4,
      when: "beforeChildren",
      type: "spring",
      // stiffness: 50
    },
  },
  closed: {
    // x: "-100%",
    width: 0,
    transition: {
      // staggerChildren: 0.05,
      // staggerDirection: -1,
      // delay: 1,
      duration: 0.2,
      ease: [0.38, 0.005, 0.215, 1],
      when: "afterChildren",
    },
  },
}

const mobileLink = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.6,
    },
  },
  closed: {
    y: 10,
    opacity: 0,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.3,
    },
  },
}

const motionAccordion = {
  closed: {
    // opacity: 0,
    height: 0,
    transition: {
      // staggerChildren: 0.05,
      // staggerDirection: -1,
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.3,
      when: "afterChildren",
    },
  },
  open: {
    // opacity: 1,
    height: "auto",
    transition: {
      staggerChildren: 0.05,
      staggerDirection: 1,
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.3,
      when: "beforeChildren",
    },
  },
}

const motionAccordionItem = {
  open: {
    x: 0,
    opacity: 1,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.6,
    },
  },
  closed: {
    x: -10,
    opacity: 0,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.3,
    },
  },
}

// motion overlay
const motionOverlay = {
  open: {
    visibility: "visible",
    opacity: 0.2,
    transition: {
      staggerChildren: 0.05,
      staggerDirection: 1,
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.4,
      when: "beforeChildren",
      type: "spring",
      // stiffness: 50
    },
  },
  closed: {
    visibility: "hidden",
    opacity: 0,
    transition: {
      // staggerChildren: 0.05,
      // staggerDirection: -1,
      // delay: 1,
      duration: 0.4,
      ease: [0.38, 0.005, 0.215, 1],
      when: "afterChildren",
    },
  },
}

const Header = ({ header, site, className }) => {
  const data = { header, site }

  const [mobileOpen, cycleMobileOpen] = useCycle(false, true)

  const [open, setOpen] = useState(false)

  const [accordionOpen, setAccordionOpen] = useState(false)

  const accordionHandler = index => {
    if (accordionOpen === index) {
      return setAccordionOpen(null)
    }
    setAccordionOpen(index)
  }

  //scroll anim
  const [fixed, setFixed] = useState(false)

  const { scrollY } = useViewportScroll()

  function update() {
    if (scrollY?.current > 100) {
      setFixed(true)
    }
    if (scrollY?.current == 0) {
      setFixed(false)
    }
  }

  useEffect(() => {
    return scrollY.onChange(() => update())
  }, [])

  // const slug = page.slug ? page.slug.current : "/"

  const motionHeader = {
    initial: {
      // top: "100%", visibility: "visible"
      // opacity: 0,
      // width: 0,
      visibility: "visible",
    },
    open: {
      // top: "0",
      // width: "20%",
      opacity: 1,
      transition: {
        staggerChildren: 0.025,
        staggerDirection: 1,
        // delay: 0.3,
        ease: [0.38, 0.005, 0.215, 1],
        duration: 0.3,
        // when: "beforeChildren",
      },
    },
    closed: {
      // bottom: "100%",
      width: 0,
      // opacity: 0,
      transition: {
        staggerChildren: 0.025,
        staggerDirection: -1,
        delay: 0.3,
        duration: 0.3,
        ease: [0.38, 0.005, 0.215, 1],
      },
    },
  }

  const motionLinks = {
    initial: { y: -10, opacity: 0 },
    open: {
      y: 0,
      opacity: 1,
      transition: {
        ease: [0.38, 0.005, 0.215, 1],
        duration: 0.6,
      },
    },
    closed: {
      y: 0,
      opacity: 0,
      transition: {
        ease: [0.38, 0.005, 0.215, 1],
        duration: 0.6,
      },
    },
  }
  const motionDropdownLinks = {
    initial: { x: -10, opacity: 0 },
    open: {
      x: 0,
      opacity: 1,
      transition: {
        ease: [0.38, 0.005, 0.215, 1],
        duration: 0.6,
      },
    },
    closed: {
      x: 0,
      opacity: 0,
      transition: {
        ease: [0.38, 0.005, 0.215, 1],
        duration: 0.2,
      },
    },
  }

  const secondaryNav = {
    initial: {
      // top: "100%", visibility: "visible"
      opacity: 0,
      // visibility: "hidden",
      // y: "-100%",
      height: 0,
    },
    open: {
      // top: "0",
      visibility: "visible",
      height: "210px",
      // width: "20%",
      // x: 0,
      opacity: 1,
      // height: "350px",
      y: 0,
      transition: {
        staggerChildren: 0.05,
        staggerDirection: 1,
        ease: [0.38, 0.005, 0.215, 1],
        duration: 0.3,
        // when: "beforeChildren",
      },
    },
    closed: {
      // bottom: "100%",
      // visibility: "hidden",
      height: 0,
      // width: 0,
      opacity: 0,
      transition: {
        // staggerChildren: 0.05,
        // staggerDirection: -1,
        when: "afterChildren",
        // delay: 1,
        duration: 0.3,
        ease: [0.38, 0.005, 0.215, 1],
      },
    },
  }

  return (
    <>
      <motion.header
        className={fixed ? "header sticky" : "header"}
        initial="initial"
        animate="open"
        exit="closed"
        variants={motionHeader}
      >
        <div className="flex gap-4 items-center justify-between w-full">
          <motion.div variants={motionLinks} style={{ margin: 0 }}>
            <Link to="/">
              <GatsbyImage
                image={site.logo.asset.gatsbyImageData}
                alt={site.siteTitle}
                objectFit="contain"
                className="h-auto w-[80px]"
              />
            </Link>
          </motion.div>
          <nav className="hidden lg:flex gap-4 text-md font-bold">
            {header.menuDesktopPrimary.items.map((link, index, arr) => {
              const isDropdown = !!link.dropdownItems

              if (isDropdown) {
                return (
                  <motion.div
                    variants={motionLinks}
                    aria-expanded={open ? "true" : "false"}
                    key={link.page.slug.current + "-" + index}
                  >
                    {/* <p>{link.title} +</p> */}
                    <Link
                      to={link.page.slug.current}
                      className="flex gap-2 items-center underline-anim"
                      onMouseEnter={() => setOpen(link.page.slug.current)}
                      activeClassName="is-current"
                    >
                      {link.title}
                      {/* <FiChevronRight /> */}
                    </Link>
                    <AnimatePresence>
                      {open == link.page.slug.current && (
                        <motion.div
                          className="header__secondary"
                          onMouseLeave={() => setOpen(false)}
                          // initial={open == link.page.slug.current ? "open" : "initial"}
                          // animate={open == link.page.slug.current ? "open" : "initial"}
                          // exit="closed"
                          initial="initial"
                          animate="open"
                          exit="closed"
                          variants={secondaryNav}
                        >
                          <nav className="header__secondary-nav">
                            {link.dropdownItems.map(dropdownItem => {
                              return (
                                <motion.div variants={motionDropdownLinks}>
                                  <Link
                                    to={dropdownItem.page.slug.current}
                                    activeClassName="is-current"
                                    className="header__secondary-nav-item underline-anim underline-anim--alt"
                                  >
                                    {dropdownItem.title}
                                  </Link>
                                </motion.div>
                              )
                            })}
                          </nav>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </motion.div>
                )
              }

              if (link._type === "navPage") {
                return (
                  <motion.div
                    variants={motionLinks}
                    key={link.page.slug.current + "-" + index}
                  >
                    <Link
                      to={link.page.slug.current}
                      onMouseEnter={() => setOpen(false)}
                      className="flex gap-2 items-center underline-anim"
                      activeClassName="is-current"
                    >
                      {link.title}
                      {/* {index === arr.length - 1 ? "" : <FiChevronRight />} */}
                    </Link>
                  </motion.div>
                )
              }
              if (link._type === "navLink") {
                return (
                  <motion.div
                    variants={motionLinks}
                    key={link._key + "-" + index}
                  >
                    <a
                      href={link.url}
                      onMouseEnter={() => setOpen(false)}
                      className="flex gap-2 items-center underline-anim"
                      // activeClassName="is-current"
                    >
                      {link.title}
                    </a>
                  </motion.div>
                )
              }
            })}
          </nav>

          <nav className="hidden lg:flex gap-4 text-md text-orange-50">
            {header.menuDesktopSecondary.items.map((link, index, arr) => {
              const isDropdown = !!link.dropdownItems

              if (isDropdown) {
                return (
                  <motion.div
                    variants={motionLinks}
                    aria-expanded={open ? "true" : "false"}
                    key={link.page.slug.current + "-" + index}
                  >
                    {/* <p>{link.title} +</p> */}
                    <Link
                      to={link.page.slug.current}
                      className="flex items-center gap-1 text-sm underline-anim"
                      onMouseEnter={() => setOpen(link.page.slug.current)}
                      activeClassName="is-current"
                    >
                      {link.title}
                    </Link>
                    <AnimatePresence>
                      {open == link.page.slug.current && (
                        <motion.div
                          className="header__secondary w-full fixed top-[100px] bg-blue-300 p-4 z-20"
                          onMouseLeave={() => setOpen(false)}
                          initial="initial"
                          animate="open"
                          exit="closed"
                          variants={secondaryNav}
                        >
                          <nav className="header__secondary-nav">
                            {link.dropdownItems.map(dropdownItem => {
                              // if (dropdownItem._type == "navPage") {
                              //   <Link
                              //     to={dropdownItem.page.slug.current}
                              //     activeClassName="is-current"
                              //     className="header__secondary-nav-item underline-anim underline-anim--alt"
                              //   >
                              //     {dropdownItem.title}
                              //   </Link>
                              // }
                              return (
                                <motion.div variants={motionDropdownLinks}>
                                  {dropdownItem._type == "navPage" && (
                                    <Link
                                      to={dropdownItem.page.slug.current}
                                      activeClassName="is-current"
                                      className="header__secondary-nav-item underline-anim underline-anim--alt"
                                    >
                                      {dropdownItem.title}
                                    </Link>
                                  )}

                                  {dropdownItem._type == "navLink" && (
                                    <a
                                      href={dropdownItem.url}
                                      className="header__secondary-nav-item underline-anim underline-anim--alt"
                                    >
                                      {dropdownItem.title}
                                    </a>
                                  )}
                                </motion.div>
                              )
                            })}
                          </nav>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </motion.div>
                )
              }

              if (link._type === "navPage") {
                return (
                  <motion.div
                    variants={motionLinks}
                    key={link.page.slug.current + "-" + index}
                  >
                    <Link
                      to={link.page.slug.current}
                      onMouseEnter={() => setOpen(false)}
                      className="flex items-center gap-1 text-sm underline-anim"
                      activeClassName="is-current"
                    >
                      {link.title}
                    </Link>
                  </motion.div>
                )
              }
              if (link._type === "navLink") {
                return (
                  <motion.div
                    variants={motionLinks}
                    key={link._key + "-" + index}
                  >
                    <a
                      href={link.url}
                      onMouseEnter={() => setOpen(false)}
                      className="flex gap-1 items-center underline-anim text-sm"
                      // activeClassName="is-current"
                    >
                      {link.title}
                    </a>
                  </motion.div>
                )
              }
            })}
          </nav>

          <button className="hamburger-menu" onClick={cycleMobileOpen}>
            <span></span>
            <span></span>
          </button>
        </div>
      </motion.header>

      {/* mobile drawer */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.aside
            initial="closed"
            animate="open"
            exit="closed"
            variants={mobileMenu}
            className="bg-primary text-orange-50 fixed z-50 top-0 bottom-0 left-0 w-[450px] "
          >
            <div className="p-6">
              <motion.button
                className="absolute top-2 right-2"
                onClick={cycleMobileOpen}
                variants={mobileLink}
              >
                <FiX className="h-[30px] w-[30px]" />
              </motion.button>

              <motion.div variants={mobileLink} style={{ margin: 0 }}>
                <Link to="/">
                  <GatsbyImage
                    image={site.logo.asset.gatsbyImageData}
                    alt={site.siteTitle}
                    objectFit="contain"
                    className="h-auto w-[80px]"
                  />
                </Link>
              </motion.div>

              <nav className="divide-y divide-orange-50">
                {header.menuDesktopPrimary.items.map((link, index, arr) => {
                  const isDropdown = !!link.dropdownItems

                  if (isDropdown) {
                    return (
                      <motion.div
                        variants={mobileLink}
                        aria-expanded={open ? "true" : "false"}
                        key={link.title + "-" + index}
                      >
                        <button
                          className="flex gap-2 items-center justify-between py-4 w-full font-bold"
                          onClick={() => accordionHandler(index)}
                        >
                          {link.title} <FiPlus />
                        </button>
                        <AnimatePresence>
                          {accordionOpen === index && (
                            <motion.div
                              variants={motionAccordion}
                              initial="closed"
                              animate="open"
                              exit="closed"
                            >
                              <nav className="flex flex-col px-2 text-sm pb-6">
                                {link.dropdownItems.map(dropdownItem => (
                                  <motion.div
                                    variants={motionAccordionItem}
                                    className="py-3"
                                  >
                                    <Link
                                      to={dropdownItem.page.slug.current}
                                      className="underline-anim text-orange-400/20"
                                    >
                                      {dropdownItem.title}
                                    </Link>
                                  </motion.div>
                                ))}
                              </nav>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </motion.div>
                    )
                  }

                  if (link._type === "navPage") {
                    return (
                      <motion.div variants={mobileLink}>
                        <Link
                          to={link.page.slug.current}
                          className="flex gap-2 items-center py-4 font-bold"
                        >
                          {link.title}
                        </Link>
                      </motion.div>
                    )
                  }
                })}
              </nav>

              <nav className="flex flex-col text-md mt-2 pt-4 divide-y divide-orange-50">
                {header.menuDesktopSecondary.items.map((link, index, arr) => {
                  const isDropdown = !!link.dropdownItems

                  if (isDropdown) {
                    return (
                      <motion.div
                        variants={mobileLink}
                        aria-expanded={open ? "true" : "false"}
                        className="py-4"
                      >
                        <button
                          className="flex gap-2 items-center justify-between w-full text-sm"
                          onClick={() => accordionHandler(index)}
                        >
                          {link.title} <FiPlus />
                        </button>
                        <AnimatePresence>
                          {accordionOpen === index && (
                            <motion.div
                              variants={motionAccordion}
                              initial="closed"
                              animate="open"
                              exit="closed"
                            >
                              <nav className="px-2 py-2">
                                {link.dropdownItems.map(dropdownItem =>
                                  dropdownItem._type === "navPage" ? (
                                    <motion.div
                                      variants={motionAccordionItem}
                                      className="py-1"
                                    >
                                      <Link
                                        to={dropdownItem.page.slug.current}
                                        className="underline-anim text-orange-400/20 text-sm"
                                      >
                                        {dropdownItem.title}
                                      </Link>
                                    </motion.div>
                                  ) : (
                                    <motion.div
                                      variants={motionAccordionItem}
                                      className="py-1"
                                    >
                                      <a
                                        href={dropdownItem.url}
                                        className="underline-anim text-sm"
                                      >
                                        {dropdownItem.title}
                                      </a>{" "}
                                    </motion.div>
                                  )
                                )}
                              </nav>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </motion.div>
                    )
                  }

                  if (!isDropdown && link._type === "navPage") {
                    return (
                      <motion.div variants={mobileLink} className="py-4">
                        <Link
                          to={link.page.slug.current}
                          onMouseEnter={() => setOpen(false)}
                          className="flex items-center gap-1 text-sm"
                        >
                          {link.title}
                        </Link>
                      </motion.div>
                    )
                  }
                })}
              </nav>
            </div>
          </motion.aside>
        )}
      </AnimatePresence>

      {/* overlay */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial="closed"
            animate="open"
            exit="closed"
            variants={motionOverlay}
            onClick={cycleMobileOpen}
            className="bg-orange-50 opacity-50 text-orange-50 fixed  top-0 bottom-0 left-0 right-0 z-20 cursor-pointer"
          >
            asdf
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default Header
